import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { AuthProvider } from './contexts/AuthContext';
import { initSentry, ErrorBoundary } from './services/sentry';
import App from './App';

initSentry();

function ErrorFallback({ resetError }) {
  return (
    <div style={{
      minHeight: '100dvh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#151515',
      color: '#FFFFFF',
      fontFamily: 'Inter, sans-serif',
      padding: '24px',
      textAlign: 'center',
    }}>
      <div style={{ maxWidth: 360 }}>
        <div style={{
          fontWeight: 900,
          fontSize: 36,
          letterSpacing: -1,
          textTransform: 'lowercase',
          marginBottom: 20,
        }}>
          dice dice baby<span style={{ color: '#151515', background: '#E8FA00', padding: '0 6px' }}>.</span>
        </div>
        <h2 style={{ color: '#E8FA00', marginBottom: 12 }}>That wasn't supposed to happen.</h2>
        <p style={{ color: '#BBB', marginBottom: 20, lineHeight: 1.5 }}>
          Something on our end broke. We've logged it and we're on it.
        </p>
        <button
          onClick={resetError}
          style={{
            background: '#E8FA00',
            color: '#151515',
            border: 'none',
            padding: '12px 24px',
            fontWeight: 900,
            borderRadius: 8,
            cursor: 'pointer',
            fontFamily: 'inherit',
            fontSize: 16,
          }}
        >
          Try again
        </button>
      </div>
    </div>
  );
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ErrorBoundary fallback={({ resetError }) => <ErrorFallback resetError={resetError} />}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </ErrorBoundary>
  </StrictMode>,
);
